export enum JobChangeType {
    WorkOrder = 'WorkOrder',
    Job = 'Job'
}

export interface JobChanged {
    type: JobChangeType;
    jobId: string;
    workOrderId?: string;
    updatedValues?: any;
}
